import { getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';

export function getScriptsDetailConfig(props) {
  // eslint-disable-next-line
  const { i18n, scope, siteMap, location } = props;
  const pageLocation = location.pathname.split('/')[location.pathname.split('/').length - 1];
  let pageName = '';
  let buttonContext = i18n.getString(_TL_('Back to scripts'));
  let pathname = getRoutePathById(siteMap, 'scripts');

  if (pageLocation === 'scriptslogs') {
    pageName = i18n.getString(_TL_('Details'));
    pathname = getRoutePathById(siteMap, 'scripts-history');
    buttonContext = i18n.getString(_TL_('Back to scripts history'));
  } else if (pageLocation === 'scriptsedit') {
    pageName = i18n.getString(_TL_('Edit Script'));
    pathname = getRoutePathById(siteMap, 'scripts-page');
  } else if (pageLocation === 'scriptscreate') {
    pageName = i18n.getString(_TL_('Create Script'));
    pathname = getRoutePathById(siteMap, 'scripts-page');
  }

  pathname += `?uid=${scope.values.uid}&cid=${scope.values.cid}`;

  if (scope.values.aid) {
    pathname += `&aid=${scope.values.aid}`;
  }

  return {
    backButtonProps: {
      url: pathname,
      buttonText: buttonContext,
    },
    breadcrumbsGeneralConfigs: {
      items: [
        {
          key: 'bulkActions',
          text: i18n.getString(_TL_('Bulk actions')),
          'aria-label': 'Bulk actions',
        },
        {
          key: 'scripts',
          text: i18n.getString(_TL_('Scripts')),
          onClick: () => {
            window.location.href = pathname;
          },
          'aria-label': 'Scripts',
        }, {
          key: 'details',
          text: pageName,
          'aria-label': pageName,
          isCurrentItem: true,
        },
      ],
      maxDisplayedItems: 3,
    },
  };
}
